
import { RouterOutlet } from '@angular/router';

import { Component, OnInit, inject } from '@angular/core';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ToastModule } from 'primeng/toast';
import { ComponentAccess } from '../common/decorators/component-access.decorator';
import { PreferencesService } from './layout/service/preferences.service';

@Component({
  selector: 'app-component',
  standalone: true,
  imports: [RouterOutlet, ToastModule, ConfirmDialogModule],
  providers: [],
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
@ComponentAccess('AppComponent')
export class AppComponent implements OnInit {
  title = 'Sequal App Admin';
  // Bootstrap preferences hydration + persistence at the app root so it
  // runs in EVERY tab as soon as the app starts — independent of which
  // route renders first or whether AppLayoutComponent loads at all.
  private readonly preferencesService = inject(PreferencesService);

  // eslint-disable-next-line @angular-eslint/no-empty-lifecycle-method
  ngOnInit() {}
}
